import { render } from "./BallcolorView.vue?vue&type=template&id=6a9fa63c&scoped=true"
import script from "./BallcolorView.vue?vue&type=script&lang=js"
export * from "./BallcolorView.vue?vue&type=script&lang=js"

import "./BallcolorView.vue?vue&type=style&index=0&id=6a9fa63c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a9fa63c"]])

export default __exports__